var map = {
	"./emotional.jpg": "067b",
	"./family.jpg": "5a13",
	"./global.less": "68b6",
	"./home1.jpg": "bcf5",
	"./home2.jpg": "3fe9",
	"./home3.jpg": "3d0b",
	"./iStock-1061013482.jpg": "696d",
	"./iStock-1131158829.jpg": "05f8",
	"./physical.jpg": "5036",
	"./shield.jpg": "6199",
	"./social.jpg": "da6d",
	"./spiritual.jpg": "3daf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";